import React from 'react'
import Nav from './Nav'

const Service = () => {
  return (
    <div className='bg'>
      <Nav />
      <h1>Service</h1>
    </div>
  )
}

export default Service
